import { render } from "./SelectOption.vue?vue&type=template&id=1c84c4a0"
import script from "./SelectOption.vue?vue&type=script&lang=js"
export * from "./SelectOption.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NicolPC\\VueWork2026\\Axxo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__